import { InnerContentItem } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { useTranslation } from "react-i18next";

import {
  useCountryName,
  useProvinceName,
} from "../../../../components/AddressInput";
import { customFieldLabels } from "../../../../utils/address-utils";

export function BirthplaceSummaryField({
  field,
}: {
  field: components["schemas"]["BirthPlaceCheckField"];
}) {
  const { t } = useTranslation();
  const getCountryName = useCountryName();
  const getProvinceName = useProvinceName(field.value?.birth_country ?? "CA");
  const labels =
    customFieldLabels[field.value?.birth_country ?? "CA"] ??
    customFieldLabels.CA;

  return (
    <>
      <InnerContentItem
        label={`${t("Country")} ${t("of birth")}`}
        testID="birth-details-summary-country-of-birth"
      >
        {getCountryName(field.value?.birth_country ?? "") ??
          field.value?.birth_country ??
          "-"}
      </InnerContentItem>

      <InnerContentItem
        label={`${labels.province_state} ${t("of birth")}`}
        testID="birth-details-summary-province-of-birth"
      >
        {getProvinceName(field.value?.birth_province_state ?? "") ??
          field.value?.birth_province_state ??
          "-"}
      </InnerContentItem>

      <InnerContentItem
        label={`${labels.city} ${t("of birth")}`}
        testID="birth-details-summary-city-of-birth"
      >
        {field.value?.birth_city ?? "-"}
      </InnerContentItem>
    </>
  );
}
